'use strict';

module.exports = function (config) {
  return function () {
    return {
      host: config.host,
      port: config.port
    };
  };
};